<template>
  <div class="form-input">
    <label>{{ label }}</label>

    <Field
      v-slot="{ field, errorMessage, value }: FieldSlot"
      :model-value="modelValue"
      :type="type"
      :name="name"
      :rules="rules"
      @update:model-value="emitModelValue"
    >
      <input
        v-bind="field"
        :type="type"
        :name="name"
        :disabled="disabled"
        class="form-control"
        @blur="emit('blur', value)"
        @focus="emit('focus', true)"
      />

      <span v-show="errorMessage" class="text-danger">{{ errorMessage }}</span>
    </Field>

    <slot name="extra" />
  </div>
</template>

<script lang="ts" setup>
import type { RuleExpression } from 'vee-validate';
import { Field } from 'vee-validate';
import type { Prop } from 'vue';
import type { FieldSlot } from '../../types';

const props = defineProps({
  type: {
    type: String,
    default: () => 'text',
  },

  modelValue: {},

  name: {
    required: true,
    type: String,
  },

  disabled: {
    type: Boolean,
    default: false,
  },

  label: {
    type: String,
    default: '',
  },

  rules: {} as Prop<RuleExpression<unknown>>,
});

const emit = defineEmits({
  'update:modelValue': (value: string | number) => value,
  blur: (value: string | number) => value,
  focus: (value: boolean) => value,
});

const emitModelValue = (newValue: any) => {
  emit('update:modelValue', newValue);
};
</script>
